module.exports = __webpack_public_path__ + "static/img/shangchuanchangjingtu2.7e67b7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/shangchuanchangjingtu2.png
// module id = tWnX
// module chunks = 24